"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NETWORK_ONLY = 'network-only';
exports.STORE_THEN_NETWORK = 'store-and-network';
exports.STORE_OR_NETWORK = 'store-or-network';
exports.STORE_ONLY = 'store-only';
exports.PAGINATION_NAME = 'usePagination';
exports.REFETCHABLE_NAME = 'useRefetchable';
exports.FRAGMENT_NAME = 'useFragment'; // pagination

exports.FORWARD = 'forward';